import {
  pricingTranslationsPt,
  featuresSectionPt,
  footerExtendedPt,
  organizationsPt,
  b2bContactPt,
  signInPt,
  a11yPt,
} from './marketingCopy.pt'
import { accountAdminCopyPt } from './accountAdminCopy/accountAdminCopy.pt'

export const pt = {
  hero: {
    title: 'Zporti',
    subtitle: 'Desafie seus Amigos. Preveja o Jogo. Vençam Juntos.',
    description:
      'Crie desafios de previsões esportivas com amigos, acompanhe suas vitórias e compita na tabela de classificação. A plataforma definitiva para competição amigável e previsões esportivas.',
  },
  siteNav: {
    home: 'Início',
    organizations: 'Organizações',
    contact: 'Contato',
    packs: 'Preços',
    signIn: 'Entrar',
    createAccount: 'Cadastrar',
    openApp: 'Abrir app',
    signedInAs: 'Conectado como',
    signedInNameFallback: 'Sua conta',
    signOut: 'Sair',
    signOutConfirmTitle: 'Sair?',
    signOutConfirmMessage: 'Você precisará entrar novamente para acessar sua conta.',
    signOutConfirm: 'Sair',
    signOutCancel: 'Cancelar',
    signOutErrorTitle: 'Erro',
    signOutError: 'Não foi possível sair. Tente de novo.',
  },
  features: {
    title: 'Por que Zporti?',
    subtitle: 'Tudo que você precisa para transformar previsões esportivas em competição amigável',
    challenge: {
      title: 'Desafiar Amigos',
      description:
        'Crie desafios de previsão personalizados e convide seus amigos para competir. Configure desafios em grupo ou enfrente-se individualmente.',
    },
    track: {
      title: 'Acompanhar Resultados',
      description:
        'Veja pontuações em tempo real, acompanhe suas previsões e monitore sua taxa de vitórias. Receba notificações instantâneas quando os resultados dos jogos chegarem.',
    },
    compete: {
      title: 'Competir e Vencer',
      description:
        'Suba na tabela de classificação, ganhe direitos de se gabar e veja quem é o melhor previsor. Celebre vitórias e acompanhe seu progresso ao longo do tempo.',
    },
    groups: {
      title: 'Grupos e temporadas',
      description:
        'Mantenha o mesmo grupo de amigos ao longo das rodadas, compare posições no grupo e crie desafios com clima de liga—não só um jogo isolado.',
    },
    locks: {
      title: 'Palpites até o apito',
      description:
        'Os palpites fecham no início da partida: mesmas regras para todos. Os resultados seguem o placar oficial—justo e sem discussão.',
    },
    organizations: {
      title: 'Organizações e marca',
      description:
        'Clubes, empresas e parceiros podem usar cores, logos e vagas de membros—a sua comunidade parece vocês dentro do app.',
    },
    avatars: featuresSectionPt.avatars,
  },
  featuresSection: featuresSectionPt,
  howItWorks: {
    title: 'Como Funciona',
    subtitle: 'Comece em três passos simples',
    step1: {
      title: 'Criar um Desafio',
      description: 'Escolha um jogo, defina suas previsões e convide amigos para participar do seu desafio.',
    },
    step2: {
      title: 'Fazer Previsões',
      description:
        'Cada participante faz suas previsões antes do jogo começar. Bloqueie suas escolhas e aguarde a ação.',
    },
    step3: {
      title: 'Ver Quem Vence',
      description:
        'Os resultados são calculados automaticamente quando os jogos terminam. Celebre vitórias e suba na tabela de classificação.',
    },
  },
  competition: {
    title: 'Competição Amigável, Emoção Real',
    description:
      'Experimente a emoção das previsões esportivas com seus amigos. Seja você um fã casual ou um entusiasta de estatísticas, o Zporti torna cada jogo mais emocionante. Desafie seus amigos, prove suas habilidades de previsão e veja quem sai vencedor.',
  },
  stats: {
    challenges: 'Desafios Ativos',
    users: 'Usuários Ativos',
    predictions: 'Previsões Feitas',
    games: 'Jogos Acompanhados',
  },
  benefits: {
    title: 'Por que Escolher Zporti?',
    subtitle: 'Tudo que você precisa para a experiência definitiva de previsões esportivas',
    realTime: {
      title: 'Atualizações em Tempo Real',
      description:
        'Receba notificações instantâneas quando os jogos começam, os placares são atualizados e os resultados chegam. Nunca perca um momento com acompanhamento de placares ao vivo e cálculos automáticos de resultados.',
    },
    social: {
      title: 'Social e Conectado',
      description:
        'Conecte-se com amigos via Gmail, convide-os facilmente e construa sua rede de previsões. Crie desafios em grupo ou enfrente-se individualmente com seus amigos mais próximos.',
    },
    smart: {
      title: 'Previsões Inteligentes',
      description:
        'Acompanhe as probabilidades, analise dados de partidas e faça previsões informadas. Veja o desempenho histórico, taxas de vitórias e estatísticas detalhadas para melhorar suas habilidades de previsão.',
    },
    fair: {
      title: 'Justo e Transparente',
      description:
        'Todos os resultados são calculados automaticamente quando os jogos terminam. Sem disputas, sem pontuação manual - apenas competição justa e vencedores claros.',
    },
  },
  faq: {
    title: 'Perguntas Frequentes',
    subtitle: 'Tudo que você precisa saber sobre Zporti',
    q1: {
      question: 'Como convido amigos?',
      answer:
        'Você pode convidar amigos de duas maneiras: conecte sua conta do Gmail para selecionar contatos facilmente ou insira endereços de e-mail manualmente. Os amigos receberão um link de convite para participar do seu desafio.',
    },
    q2: {
      question: 'Quando as previsões são bloqueadas?',
      answer:
        'As previsões devem ser feitas antes do início do jogo. Uma vez que uma partida começa, todas as previsões são bloqueadas e não podem ser alteradas. Isso garante competição justa para todos.',
    },
    q3: {
      question: 'Como os vencedores são determinados?',
      answer:
        'Os vencedores são calculados automaticamente quando os jogos terminam. O sistema compara todas as previsões com os resultados reais das partidas e atualiza as tabelas de classificação em tempo real.',
    },
    q4: {
      question: 'Posso criar desafios em grupo?',
      answer:
        'Sim! Você pode criar desafios com vários amigos ou enfrentar-se individualmente com amigos. Configure competições em grupo para ver quem tem as melhores habilidades de previsão.',
    },
  },
  packsPage: {
    pageTitle: 'Planos e Preços',
  },
  contact: {
    title: 'Fale conosco',
    subtitle:
      'Dúvidas sobre o produto, feedback, imprensa ou parcerias—envie uma mensagem abaixo ou um e-mail direto. Lemos tudo.',
    emailLabel: 'Envie-nos um e-mail para',
    email: 'info@zporti.com',
    form: {
      nameLabel: 'Nome',
      emailLabel: 'E-mail',
      messageLabel: 'Mensagem',
      submitButton: 'Enviar Mensagem',
      submitting: 'Enviando...',
      successMessage: 'Obrigado! Sua mensagem foi enviada. Entraremos em contato em breve.',
      errorMessage: 'Falha ao enviar mensagem. Por favor, tente novamente mais tarde.',
      namePlaceholder: 'Nome completo',
      emailPlaceholder: 'seu.email@exemplo.com',
      messagePlaceholder: 'Conte-nos o que está pensando...',
      validation: {
        nameRequired: 'O nome é obrigatório',
        nameTooLong: 'O nome deve ter 50 caracteres ou menos',
        emailRequired: 'O e-mail é obrigatório',
        emailInvalid: 'Por favor, insira um endereço de e-mail válido',
        messageRequired: 'A mensagem é obrigatória',
        messageTooLong: 'A mensagem deve ter 500 caracteres ou menos',
        invalidCharacters: 'Caracteres inválidos detectados. Por favor, remova qualquer formatação especial.',
      },
    },
  },
  footer: {
    title: 'Pronto para Começar?',
    subtitle:
      'Junte-se ao Zporti hoje e comece a desafiar seus amigos. Crie seu primeiro desafio de previsão em segundos.',
    privacyPolicy: 'Política de privacidade',
    termsOfService: 'Termos de uso',
    dataDeletion: 'Exclusão de dados',
    credits: 'Créditos',
    privacyControls: 'Controles de privacidade',
    ...footerExtendedPt,
  },
  pricing: pricingTranslationsPt,
  organizations: organizationsPt,
  b2bContact: b2bContactPt,
  signIn: signInPt,
  a11y: a11yPt,
  accountAdmin: accountAdminCopyPt,
  legal: {
    backToHome: 'Voltar para o início',
    backToPrivacyAndData: 'Voltar',
    privacyDocumentTitle: 'Política de privacidade',
    dataDeletionDocumentTitle: 'Instruções de exclusão de dados',
    termsDocumentTitle: 'Termos de uso',
    creditsDocumentTitle: 'Créditos',
    aboutDocumentTitle: 'Sobre a Zporti',
    supportDocumentTitle: 'Suporte',
    documentVersionLine: 'Última atualização {date} · versão {version}',
    privacyControlsCallout:
      'Precisa alterar consentimentos ou solicitar uma cópia dos seus dados? Abra os controles de privacidade na sua conta.',
    openPrivacyControls: 'Abrir controles de privacidade',
    signInForPrivacyControls: 'Entre para abrir os controles de privacidade',
  },
  privacyControls: {
    title: 'Controles de privacidade',
    subtitle: 'Gerencie o consentimento de marketing e solicite uma cópia dos dados da sua conta.',
    marketingEmailsTitle: 'E-mails de marketing',
    marketingEmailsHint: 'Você pode ativar ou retirar o consentimento a qualquer momento.',
    analyticsTrackingTitle: 'Rastreamento de analytics',
    analyticsTrackingHint: 'Ative ou desative o rastreamento de analytics para este dispositivo/navegador.',
    accountDataCopyTitle: 'Cópia dos dados da conta',
    accountDataCopyHint:
      'Baixe uma cópia em JSON dos dados pessoais vinculados à sua conta (disponível uma vez a cada 24 horas).',
    enabled: 'Ativado',
    disabled: 'Desativado',
    downloadMyData: 'Baixar meus dados',
    nextExportAvailable: 'Próxima exportação disponível',
    close: 'Fechar',
    deleteYourAccount: 'Excluir sua conta',
    deleteYourAccountHint:
      'Continue para confirmar na próxima tela. Isso remove permanentemente sua conta e os dados relacionados.',
  },
}

